/*
 * @Author: ken yang
 * @Date: 2023-05-07 11:52:51
 * @LastEditTime: 2023-07-28 16:12:58
 * @LastEditors: ken yang
 * @Description:
 * @FilePath: /uexch_h5/src/view/user/index.js
 */
const ProofOfReserves = () => import('@/view/proofOfReserves/ProofOfReserves.vue')

const routes = [
  {
    path: '/proofOfReserves',
    component: ProofOfReserves,
  },
]
const components = {}

export default {
  routes,
  components,
}
